// Küçük sınıf-adı birleştirme yardımcısı (blok View'ları scoped stil sınıfını ekler).

/** İki sınıf adını birleştirir (scoped varsa ekler). */
export function cx(base: string, scoped?: string): string {
  return scoped ? `${base} ${scoped}` : base;
}
